module.exports = __webpack_public_path__ + "img/b512acf.jpg";